class ConfigSvc {
    config = {};
    /**
     * Loads the configuration from app.json
     * @returns {class} the configuration service class object
     */
    loadConfig = async () => {
        this.config = await fetch("/app.json?t=" + new Date().getTime())
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }
                throw response;
            })
            //.then((json) => {
            //    return JSON.parse(atob(json.c));
            //})
            .catch((ex) => {
                console.error("configService load error:", ex);
                return null;
            });

        return this.config;
    }

    /**
     * Returns the tenant id from the configuration object
     * @returns {string} the tenant id
     */
    get appId() {
        return process.env.REACT_APP_APP_ID || this.config.appId;
    }

    /**
     * Returns the unique Microsoft authentication (client) ID 
     * @returns {string} the Microsoft authentication client ID
     */
    get msAuthClientId() {
        return this.config.msAuthClientId;
    }

    /**
     * Returns the whether to use GCC High authentication
     * @returns {boolean}
     */
    get msAuthIsGccHigh() {
        return this.config.msAuthIsGccHigh;
    }

    /**
     * Returns the unique Google authentication (client) ID 
     * @returns {string} the Google authentication client ID
     */
    get googleAuthClientId() {
        return this.config.googleAuthClientId;
    }

    /**
     * Returns the gateway URL for routing requests to an API
     * @returns {string} - the gateway URL
     */
    get adminGatewayUrl() {
        return this.config.adminGatewayUrl;
    }
}

export const configService = new ConfigSvc();